<template>
    <div>
        <h2>{{messages.questionnaire_note_heading}}</h2>
        <p>{{messages.questionnaire_note_introduction}}</p>
        <div class="clean-form">
            <div class="form__row">
                <textarea v-model="note"></textarea>
                <p class="error" v-show="!$v.note.required">{{messages.questionnaire_error_note_required}}</p>
                <input type="button" class="btn btn-primary" :value="messages.questionnaire_note_save_btn"
                       @click.prevent="saveNote">
            </div>
            <div class="form__row">
                <h2>{{messages.questionnaire_photos_heading}}</h2>
                <p>{{messages.questionnaire_photos_introduction}}</p>

                <upload-or-capture-photo
                        :photos="entity.photos"
                        :scanId="scanId"
                        :questionId="questionId">
                </upload-or-capture-photo>
            </div>
        </div>
    </div>
</template>

<script>
    import {Api as coreApi, Bovemij, Mixins} from '@bvm/core';
    import UploadOrCapturePhoto from './upload-or-capture-photo'

    export default {
        mixins: [Mixins.Lang],
        components: {UploadOrCapturePhoto},
        props: {
            scanId: {type: String, required: true},
            questionId: {type: String, required: true},
            entity: {type: Object, required: true},
            callback: {type: Function, required: true}
        },
        data: function () {
            return {
                messageKeys: [
                    'questionnaire_note_heading',
                    'questionnaire_note_introduction',
                    'questionnaire_error_note_required',
                    'questionnaire_note_save_btn',
                    'questionnaire_photos_heading',
                    'questionnaire_photos_introduction',
                    'questionnaire_error_note_not_saved'
                ],
                messages: [],
                note: this.entity.note,
                storedNote: this.entity.note,
            };
        },
        validations: {
            note: {
                required: function (value) {
                    return this.entity.photos.length === 0 || !!value;
                }
            }
        },
        methods: {
            isDirty() {
                return this.storedNote !== this.note;
            },
            hasChanged() {
                return this.storedNote !== this.entity.note;
            },
            saveNote() {
                if (!this.isDirty()) {
                    this.$emit('dismiss-modal');
                }
                this.callback(this.note).then(() => {
                    this.storedNote = this.note;
                    this.$emit('dismiss-modal');
                    this.entity.note = this.note;
                }).catch((error) =>
                    coreApi.Notification.notifyFailure(error, this.messages.questionnaire_error_note_not_saved)
                );
            },
            beforeClose() {
                this.$v.note.$touch();

                if (this.$v.note.$invalid) {
                    return Bovemij.Modal.Action.NOTHING;
                }

                return {
                    action: this.isDirty() ? Bovemij.Modal.Action.CONFIRM : Bovemij.Modal.Action.DISMISS,
                    params: {hasChanged: this.hasChanged()}
                };
            }
        }
    }
</script>

